import Button from 'plaid-threads/Button';
import Image from 'src/components/Image';
import IconButton from 'plaid-threads/IconButton';
import MenuS1 from 'plaid-threads/Icons/MenuS1';
import React, { useState, useEffect } from 'react';
import cx from 'classnames';
import Link from 'next/link';
import { useRouter } from 'next/router';
import Sidebar from '../Sidebar';
import Search from '../Search';
import styles from './index.module.scss';

export interface Props {
  baseUrl: string;
}

const Navbar: React.FC<Props> = (props: Props) => {
  const { baseUrl, ...restProps } = props;
  const [showSidebar, setShowSidebar] = useState(false);
  const router = useRouter();
  const routerEvents = router.events;
  useEffect(() => {
    if (!routerEvents) {
      return;
    }
    const closeSidebar = () => setShowSidebar(false);
    routerEvents.on('routeChangeStart', closeSidebar);
    return () => routerEvents.off('routeChangeStart', closeSidebar);
  }, [routerEvents]);

  return (
    <>
      <nav
        className={cx(styles.navbar, styles.mainNav)}
        aria-label='Secondary'
        {...restProps}
      >
        <div className={styles.leftColumn}>
          <div className={styles.homeLink}>
            <Link
              href={baseUrl}
              rel='noopener noreferrer'
              className={styles.logo}
            >
              <Image
                className={styles.logoImage}
                src='/assets/img/navbar/logo.svg'
                alt='Plaid logo'
                width='80'
                height='30.47'
              />
              <span className={styles.logoText}>Core Exchange</span>
            </Link>
          </div>
          <div className={styles.search}>
            <Search />
          </div>
        </div>

        <div className={styles.rightColumn}>
          <Link href='/' className={cx(styles.link, styles.desktopOnly)}>
            Plaid.com
          </Link>
          <Button
            href='https://plaid.com/products/core-exchange/#contactForm'
            target='_blank'
            className={cx('signup-attach-utm', styles.desktopOnly)}
            secondary
          >
            Get Started
          </Button>
          <IconButton
            className={styles.sidebarToggle}
            accessibilityLabel='Open nav'
            icon={<MenuS1 />}
            onClick={() => {
              setShowSidebar(true);
            }}
          />
        </div>
      </nav>
      <Sidebar
        mobile
        closed={!showSidebar}
        onClose={() => setShowSidebar(false)}
        className={styles.sidebar}
        baseUrl={baseUrl}
      />
      {showSidebar && (
        <div
          className={styles.sidebarBackdrop}
          role='button'
          tabIndex={-1}
          onClick={() => setShowSidebar(false)}
          onKeyDown={(e) => {
            if (e.keyCode === 27) {
              // escape
              setShowSidebar(false);
            }
          }}
        ></div>
      )}
    </>
  );
};

export default Navbar;
